import React from 'react';
import { Button } from '../ui/button';
import { Undo, Redo, Users, User } from 'lucide-react';
import { Badge } from '../ui/badge';

export default function EditorToolbar({ 
  onUndo, 
  onRedo, 
  canUndo, 
  canRedo, 
  editMode, 
  onEditModeChange 
}) {
  return (
    <div className="flex items-center gap-2">
      {/* Undo/Redo */}
      <div className="flex items-center gap-1 p-1 bg-muted rounded-xl">
        <Button
          variant="ghost"
          size="sm"
          onClick={onUndo}
          disabled={!canUndo}
          className="rounded-lg h-8 w-8 p-0"
          title="Undo (Ctrl+Z)"
        >
          <Undo className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onRedo}
          disabled={!canRedo}
          className="rounded-lg h-8 w-8 p-0"
          title="Redo (Ctrl+Y)"
        >
          <Redo className="w-4 h-4" />
        </Button>
      </div>

      {/* Edit Mode Toggle */}
      <div className="flex items-center gap-1 p-1 bg-muted rounded-xl">
        <Button
          variant={editMode === 'individual' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onEditModeChange('individual')}
          className="rounded-lg h-8 px-3"
        >
          <User className="w-3 h-3 mr-1" />
          Individual
        </Button>
        <Button
          variant={editMode === 'all' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onEditModeChange('all')}
          className="rounded-lg h-8 px-3"
        >
          <Users className="w-3 h-3 mr-1" />
          Edit All
        </Button>
      </div>

      {editMode === 'all' && (
        <Badge className="bg-primary text-primary-foreground">
          Editing All Badges
        </Badge>
      )}
    </div>
  );
}
